import { useQuery } from '@tanstack/react-query';
import { useAuthContext } from 'modules/auth/context';
import * as Api from '../api';
import type { SubjectProgress } from '../types';

/**
 * The learner's progress per subject of a category, by subject key. The key carries the learner, so a second
 * account on the same browser never sees the first's results. Progress only decorates the cards, so a failed
 * load leaves them plain and is not retried.
 */
export const useMySubjectProgress = (category: string | undefined, enabled = true) => {
  const { state } = useAuthContext();
  const userId = state.user?.id;
  return useQuery({
    queryKey: ['public-test-subject-progress', userId, category],
    enabled: Boolean(userId && category && enabled),
    queryFn: async ({ signal }) => (await Api.MySubjectProgress(category!, signal)).data.data,
    select: (rows): Map<string, SubjectProgress> => new Map(rows.map((row) => [row.key, row])),
    // A test finished since the last visit changes the level, so a kept answer would show the old one.
    gcTime: 0,
    retry: false,
  });
};

export default useMySubjectProgress;
